function normalizeRoles(payload) {
  if (!payload || typeof payload !== 'object' || !Array.isArray(payload.roles)) {
    return [];
  }

  return payload.roles;
}

function normalizePermissions(payload) {
  if (!payload || typeof payload !== 'object' || !Array.isArray(payload.permissions)) {
    return [];
  }

  return payload.permissions;
}

function normalizeRole(role) {
  return {
    id: Number(role?.id || 0),
    name: String(role?.name || '').trim(),
    slug: String(role?.slug || '').trim(),
    description: String(role?.description || '').trim(),
    isSystem: Boolean(role?.isSystem),
    permissions: Array.isArray(role?.permissions)
      ? [...new Set(role.permissions.map((item) => String(item || '').trim()).filter(Boolean))]
      : [],
  };
}

export function mapAclPermissionsResponseToDto(payload) {
  return normalizePermissions(payload).map((permission) => ({
    key: String(permission?.key || '').trim(),
    group: String(permission?.group || '').trim(),
    description: String(permission?.description || '').trim(),
  }));
}

export function mapAclRolesResponseToDto(payload) {
  return normalizeRoles(payload).map(normalizeRole);
}

export function mapAclProfileRolesResponseToDto(payload) {
  return normalizeRoles(payload).map(normalizeRole);
}

export function mapAclRolePayloadFromForm(form) {
  return {
    name: String(form?.name || '').trim(),
    slug: String(form?.slug || '').trim(),
    description: String(form?.description || '').trim(),
    permissions: Array.isArray(form?.permissionKeys)
      ? [...new Set(form.permissionKeys.map((item) => String(item || '').trim()).filter(Boolean))].sort()
      : [],
  };
}
